import { Inject, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Invoice, ISubscriptionChange } from '@shared/recurly/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class RecurlyService {
  private readonly basePath = `/v.1/recurly`;

  constructor(
    private readonly http: ApiClientService,
    @Inject(DOCUMENT) private document: HTMLDocument,
  ) { }

  getApiKey() {
    return this.http.get(`${this.basePath}/apiKey`, {responseType: 'text'});
  }

  getInvoices(): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(`${this.basePath}/invoices`);
  }

  downloadInvoice(id: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.http.get(`${this.basePath}/invoices/${id}/download`, {headers: headers, responseType: 'blob'})
      .pipe(
        tap(data => this.downLoadFile(data, 'application/pdf', `invoice-${id}.pdf`)),
      );
  }

  getPendingSubscriptionChange(uuid: string): Observable<ISubscriptionChange> {
    return this.http.get<ISubscriptionChange>(`${this.basePath}/pendingSubscriptionChange`, { params: { uuid } })
  }

  downLoadFile(data: any, type: string, name: string) {
    let downloadLink = this.document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob([data], {type}));
    downloadLink.setAttribute('download', name);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
